import { Component, inject, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BaseListComponent, BaseListPaginatorComponent, NewsArticleService } from '../../common';
import { MatChipsModule } from '@angular/material/chips';
import { GlobalInfo, HasIdName, NewsArticle } from '../../model';
import { OverflowGradientDirective } from '../../common/overflow-gradient.directive';
import { TranslateModule } from '@ngx-translate/core';

interface Filter {
  search?: string | null;
  risks?: string[];
  locations?: string[];
  noRating?: boolean;
  all?: boolean;
}

@Component({
  selector: 'app-news-dialog',
  templateUrl: 'news-dialog.component.html',
  styleUrls: ['news-dialog.component.scss'],
  providers: [{ provide: BaseListComponent, useExisting: NewsDialogComponent }],
  imports: [
    MatDialogModule,
    MatChipsModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    BaseListPaginatorComponent,
    OverflowGradientDirective,
    TranslateModule,
  ],
})
export class NewsDialogComponent implements OnInit {
  data = inject<{
    risks: HasIdName[];
    locations: HasIdName[];
  }>(MAT_DIALOG_DATA);

  globalInfo: GlobalInfo = { countries: [], siteType: [], resolveStates: () => [] };
  filter: Filter = {} as any;
  private service = inject(NewsArticleService);

  constructor() {
    const data = this.data;

    this.filter = {
      risks: data.risks.map(({ id }) => id),
      locations: data.locations.map(({ id }) => id),
      // Same filter as the risk button's count (POST /api/news-article/count): rated and currently
      // valid only — `all: false` applies the date window, so the list never shows more than the
      // button promised (app#295).
      noRating: false,
      all: false,
    };
  }

  async ngOnInit() {
    await this.search();
  }

  private search = async () => {
    this.page = {
      ...(await this.service.listLimit(this.filter, 'page')),
      search: () => this.search(),
    };
  };

  page = {
    totalElements: 0,
    pageSize: 0,
    pageNumber: 0,
    content: [] as NewsArticle[],
    search: () => this.search(),
  };
}
